module.exports = __webpack_public_path__ + "static/media/normalcar2.ce2f8c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/normalcar2.png
// module id = 3309
// module chunks = 0